// extracted by mini-css-extract-plugin
export default {"drop-down-icon":"PositionMenu_drop-down-icon__iXk4P"};